import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ClinicalFeedbackConstants } from '@app/clinical-feedback/clinical-feedback-constants';
import { FormElementModel } from '@app/clinical-feedback/clinical-feedback.model';
import { NewClinicalFeedbackFormHelper } from '@app/clinical-feedback/new-clinical-feedback/new-clinical-feedback.helper';

@Component({
    selector: 'app-text',
    templateUrl: './text.component.html',
    styleUrls: ['./text.component.scss']
})
export class TextComponent {
    @Input() parentFormGroup!: UntypedFormGroup;
    @Input() formElementModel!: FormElementModel;
    @Input() readOnly = false;

    get tooltip() {
        if (!this.formElementModel.enableTooltip) {
            return '';
        }
        return this.control.value;
    }

    get control() {
        if (!this.formElementModel.id) {
            throw new Error(`formElementId not set for '${this.formElementModel.label}'.`);
        }
        const formControl = this.parentFormGroup.get(this.formElementModel.id);
        if (this.readOnly && !formControl.value) {
            formControl.setValue(ClinicalFeedbackConstants.EMPTY_VALUE);
        }
        return formControl;
    }

    get asterisk() {
        return NewClinicalFeedbackFormHelper.getAsteriskIfRequired(this.control);
    }
}
